import { get } from "lodash";
import request from "../services/requestService";
import { NOTIFICATION_TOOGLE } from "../constant";
import * as apiServices from "../services/apiServices";

export const getNotificationActiveInfoAction = (requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: NOTIFICATION_TOOGLE.NOTIFICATION_TOOGLE_START
    });
    return requestMethod(apiServices.getNotificationActiveInfoApi())
      .then(response => {
        const payload = {
          data: get(response, "data.data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
        dispatch({
          type: NOTIFICATION_TOOGLE.NOTIFICATION_TOOGLE_SUCCESS,
          payload
        });
        return payload;
      })
      .catch(() => {
        dispatch({
          type: NOTIFICATION_TOOGLE.NOTIFICATION_TOOGLE_FAILURE
        });
      });
  };
};

export const setNotificationActiveInfoAction = (
  requestMethod = request,
  params
) => {
  return function(dispatch) {
    dispatch({
      type: NOTIFICATION_TOOGLE.NOTIFICATION_TOOGLE_START
    });
    return requestMethod(apiServices.setNotificationActiveInfoApi(params))
      .then(response => {
        const payload = {
          data: get(response, "data.data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
        dispatch({
          type: NOTIFICATION_TOOGLE.NOTIFICATION_TOOGLE_SUCCESS,
          payload
        });
        // display toast message
        return payload;
      })
      .catch(() => {
        dispatch({
          type: NOTIFICATION_TOOGLE.NOTIFICATION_TOOGLE_FAILURE
        });
      });
  };
};
